import cssVariables from 'tfs.css-variables'

export default {
  container: {
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  popup: {
    fontSize: '1rem',
    maxWidth: '30rem',
    padding: '2rem',
    backgroundColor: cssVariables.colorWhite,
    borderRadius: '0.7rem',
  },
  button: {
    marginTop: '1rem',
  },
}
